/* eslint-disable react/prop-types */
import React from 'react'
import './ReviewFlag.css'

/*
 * ReviewFlag — the per-line "needs review" marker on the lyric editor: a small
 * amber triangle in the left margin with a hover "what is this" tooltip.
 * Renders nothing when the line isn't flagged. Dark-only.
 *
 * `flag` is EditLyrics' line.sync_flags ({ types: [...] }) or null/undefined.
 */

const ATTENTION_TIP =
  'FeelsSync flagged this line for review — double-check the timing.'

export default function ReviewFlag({ flag }) {
  if (!flag || !Array.isArray(flag.types) || flag.types.length === 0) return null
  return (
    <span className="rf rf-pennant" role="status" aria-label="Line needs review">
      <span className="rf-pennant-flag" aria-hidden="true" />
      <span className="rf-tip" role="tooltip">
        {ATTENTION_TIP}
      </span>
    </span>
  )
}
